<template>
  <div class="sections-container">
    <div class="header-sections">
      <span class="title-section">Negocios</span>

      <div class="filter-colum-sections">

        <v-text-field
            style="width: 320px;"
            type="text"
            placeholder="Buscar"
            v-model="currentSearch"
            color="#222222"
            clearable
             @click:clear="clearSearch"
            variant="underlined">
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-magnify" size="small"/>
            </template>
          </v-text-field>

          <div class="select-filter-container">
            <span class="title-filter">Negocios:</span>
            <v-select
              v-model="filterSelected"
              class="select-filter no-bg"
              variant="solo"
              density="compact"
              :items="filterData"/>
          </div>

      </div>

    </div>

    <div class="container-content-section">
      <business-card-vue v-for="item in businessFilter" :key="item._id"
        :busines="item" @refreshList="getBusines()"/>
    </div>

    <div class="fab-button" @click="addBusiness">
      <v-icon icon="mdi-plus"/>
    </div>

    <add-edit-business ref="addEditModal" @refreshList="getBusines()"/>
</div>
</template>
<script>
import BusinessCardVue from '../cards/BusinessCard.vue'
import AddEditBusiness from '../forms/AddEditBusiness.vue'
import businessApi from '@/api/businessApi'
export default {
  name: 'CommerciaVueBusiness',
  components: {
    BusinessCardVue,
    AddEditBusiness
  },
  data () {
    return {
      business: [],
      businessFilter: [],
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: ['Todos', 'Activos', 'Bloqueados']
    }
  },
  created () {
    this.getBusines()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.getBusines()
    },
    filterSelected (newVal, oldVal) {
      this.getDataFilter()
    }
  },
  methods: {
    async getBusines () {
      this.business = await businessApi.list(this.currentSearch)
      this.getDataFilter()
    },
    clearSearch () {
      this.currentSearch = ''
      this.getBusines()
    },

    getDataFilter () {
      this.businessFilter = []
      if (this.filterSelected === 'Todos') {
        this.businessFilter = this.business
      } else {
        for (const item of this.business) {
          if (item.active && this.filterSelected === 'Activos') {
            this.businessFilter.push(item)
          }
          if (!item.active && this.filterSelected === 'Bloqueados') {
            this.businessFilter.push(item)
          }
        }
      }
    },

    addBusiness () {
      this.$refs.addEditModal.add()
    }

  }
}
</script>
<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
</style>
